import type { CSSProperties } from "react";
import clsx from "clsx";
import styles from "./Skeleton.module.scss";

export interface SkeletonProps {
  /** The reserved shape: a text `line`, a KPI `tile`, or a `block`. */
  variant?: "line" | "tile" | "block";
  width?: string | number;
  height?: string | number;
  className?: string;
}

/**
 * A reserved-size loading placeholder (Skeleton / — "skeleton vocabulary on all surfaces … never
 * stale tenant data"). Shimmer honors `prefers-reduced-motion` (static). `aria-hidden` — the live region owns the
 * "loading" announcement.
 */
export function Skeleton({ variant = "line", width, height, className }: SkeletonProps) {
  const style: CSSProperties = {};
  if (width != null) style.inlineSize = typeof width === "number" ? `${width}px` : width;
  if (height != null) style.blockSize = typeof height === "number" ? `${height}px` : height;
  return <span className={clsx(styles.skeleton, styles[variant], className)} style={style} aria-hidden="true" />;
}
